import legitimizerAPI from '../api';
import { DocumentType, KybProcess, KybProcessConfiguration, KybSubmissionData, KybSubmissionResponse } from '../types';

export const fetchLatestKybProcess = (merchantId: string) => {
  return legitimizerAPI
    .get<KybProcess>(`api/v1/kyb/merchants/${merchantId}/processes/latest`)
    .then(response => response.data);
};

export const fetchKybProcesses = (merchantIds: string[]) =>
  Promise.all(merchantIds.map(id => fetchLatestKybProcess(id)));

export const fetchOpenKybProcesses = (merchantIds: string[]) =>
  fetchKybProcesses(merchantIds).then(processes => processes.filter(process => process.state === 'OPEN'));

export const fetchKybProcessConfiguration = (processId: number) => {
  return legitimizerAPI
    .get<KybProcessConfiguration>(`api/v1/kyb/processes/${processId}/configuration`)
    .then(response => response.data);
};

export const fetchKybSubmissionData = (processId: number) => {
  return legitimizerAPI
    .get<KybSubmissionResponse>(`api/v1/kyb/processes/${processId}/submissions/latest`)
    .then(response => response.data);
};

export const updateSubmissionData = (processId: number, submissionData: KybSubmissionData) => {
  return legitimizerAPI
    .put<KybSubmissionData>(`api/v1/kyb/processes/${processId}/submissions`, submissionData)
    .then(response => response.data);
};

export const updateSubmissionDocuments = (
  processId: number,
  documentType: DocumentType,
  payload: {
    existingIds: number[];
    newDocuments: File[];
  },
) => {
  const formData = new FormData();

  payload.newDocuments.forEach(document => {
    formData.append('newDocuments', document);
  });

  payload.existingIds.forEach(existingDocumentId => {
    formData.append('existingDocumentIds', `${existingDocumentId}`);
  });

  formData.append('source', 'merchant');

  return legitimizerAPI
    .put(`api/v3/kyb/processes/${processId}/submissions/documents/type/${documentType}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(response => response.data);
};

export const submitForReview = (processId: number, currentLocale: string) => {
  return legitimizerAPI
    .post<unknown>(`api/v1/kyb/processes/${processId}/submit?language=${currentLocale}`)
    .then(response => response.data);
};
